import produce from 'immer';
import {
	FETCH_POSTOFFICES_PENDING,
	FETCH_POSTOFFICES_FULFILLED,
	FETCH_POSTOFFICES_FAILED,
} from '../constants/actions/postOfficeActions';

const postOfficeReducer = produce(
	(draft, action) => {
		switch (action.type) {
			case FETCH_POSTOFFICES_PENDING: {
				draft.postOfficesLoading = true;
				draft.postOfficesError = false;
				break;
			}
			case FETCH_POSTOFFICES_FULFILLED: {
				draft.postOfficesLoading = false;
				draft.postOffices = action.payload.postOffices;
				draft.postOfficesError = false;
				break;
			}
			case FETCH_POSTOFFICES_FAILED: {
				draft.postOfficesLoading = false;
				draft.postOfficesError = true;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		postOffices: null,
		postOfficesLoading: false,
		postOfficesError: false,
	}
);

export default postOfficeReducer;
